import pulse, { TrackerData } from "@finn-no/pulse-sdk";

const trackPageViewEvent = (trackerData: TrackerData) => {
    if (typeof window === "undefined") {
        return;
    }

    if (trackerData) {
        pulse.trackPageView(trackerData);
    }
};

const trackClickEvent = (trackerData: TrackerData, targetId?: string, objectName?: string) => {
    if (typeof window === "undefined") {
        return;
    }

    if (trackerData) {
        const trackingEvent: TrackerData = {
            ...trackerData,
            ...(objectName && {
                object: {
                    ...trackerData.object,
                    name: objectName,
                },
            }),
            ...(targetId && {
                target: {
                    ...trackerData.target,
                    id: targetId,
                },
            }),
        };
        pulse.trackEvent(trackingEvent);
    }
};

const trackViewEvent = (trackerData: TrackerData) => {
    if (typeof window === "undefined") {
        return;
    }

    if (trackerData) {
        pulse.trackEvent(trackerData);
    }
};

export { trackClickEvent, trackPageViewEvent, trackViewEvent };
